import { all, call, fork, put, takeEvery } from 'redux-saga/effects';

import { customHeaders, supersetUrl } from '../../../../../Containers/Config/index.js';
import { CLOUD_INFRA_PAIN_MINUTES, CLOUD_INFRA_PAIN_MINUTES_ERROR, CLOUD_INFRA_PAIN_MINUTES_SUCCESS } from '../../../actionType.js';
import apiCall from '../../../apiCall.js';

function* cloudInfraPainMinutes({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const response = yield call(apiCall, {
      url: `${supersetUrl}/api/v1/chart/data`,
      method: 'POST',
      headers: {
        ...filteredHeaders,
        ...payload?.headers,
      },
      data: payload?.data,
    });

    if (response.status === 200) {
      yield put({
        type: CLOUD_INFRA_PAIN_MINUTES_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: CLOUD_INFRA_PAIN_MINUTES_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: CLOUD_INFRA_PAIN_MINUTES_ERROR, payload: error });
  }
}

export function* watchCloudInfraPainMinutes() {
  yield takeEvery(CLOUD_INFRA_PAIN_MINUTES, cloudInfraPainMinutes);
}

function* cloudInfraPainMinutesSaga() {
  yield all([fork(watchCloudInfraPainMinutes)]);
}

export default cloudInfraPainMinutesSaga;
